// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"e89950bc","815":"059d7e57","2827":"059d7e57","6701":"3de1f365"}[chunkId] + ".chunk.css";
};